const addHttpPrefix = (value) => {
  if (/^http/i.test(value) || value.length === 0) {
    return value;
  } else {
    const placeholder = 'http://';
    return placeholder + value;
  }
};

export default addHttpPrefix;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/utils/addHttpPrefix.js